export default class InvoiceCount {
    static fromData(data) {
        if (!data) {
            return;
        }

        let invoiceCount = new InvoiceCount();
        invoiceCount.count = data.count;

        return invoiceCount;
    }
}
